export * from './checkbox';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/checkbox/index.js
// module id = 675
// module chunks = 3